module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('div', [_c('loader')], 1) : _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('nav', {
    attrs: {
      "aria-label": "breadcrumb"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item",
    attrs: {
      "aria-current": "page"
    }
  }, [_vm._v(_vm._s(_vm.request.objectId))]), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item",
    attrs: {
      "aria-current": "page"
    }
  }, [_vm._v(_vm._s(_vm.step.name))])])]), _vm._v(" "), _c('h1', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("Convites ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-sm btn-primary",
    staticStyle: {
      "margin-top": "-10px"
    },
    attrs: {
      "to": {
        name: 'RequestInviteSelect'
      },
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  }), _vm._v(" Adicionar Convidado\n      ")])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(!_vm.invites || _vm.invites.length === 0) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n      Nenhum convite criado.\n    ")]) : _c('b-table', {
    attrs: {
      "items": _vm.invites,
      "fields": _vm.requestsfields,
      "striped": "",
      "hover": ""
    },
    scopedSlots: _vm._u([{
      key: "user",
      fn: function(item) {
        return _c('span', {}, [(item.value.get) ? _c('span', [_vm._v(_vm._s(item.value.get('name')))]) : _vm._e()])
      }
    }, {
      key: "expiration",
      fn: function(item) {
        return _c('span', {}, [(item.value) ? _c('span', {
          class: {
            danger: new Date(item.value) < new Date()
          }
        }, [_vm._v(_vm._s(_vm.formatExpirationDate(item.value)))]) : _c('span', [_vm._v("Não")])])
      }
    }, {
      key: "canComment",
      fn: function(item) {
        return _c('span', {}, [(item.value) ? _c('span', [_vm._v("Sim")]) : _c('span', [_vm._v("Não")])])
      }
    }, {
      key: "canEdit",
      fn: function(item) {
        return _c('span', {}, [(item.value) ? _c('span', [_vm._v("Sim")]) : _c('span', [_vm._v("Não")])])
      }
    }, {
      key: "createdAt",
      fn: function(item) {
        return _c('span', {}, [_vm._v("\n          " + _vm._s(_vm.formatDate(item.value)) + "\n      ")])
      }
    }, {
      key: "actions",
      fn: function(item) {
        return _c('span', {}, [_c('button', {
          staticClass: "btn btn-danger btn-xs",
          on: {
            "click": function($event) {
              return _vm.remove(item.item.objectId)
            }
          }
        }, [_vm._v("Remover")])])
      }
    }])
  }), _vm._v(" "), _c('hr')], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.$router.go('-1')
      }
    }
  }, [_vm._v("Voltar")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e5aba69a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RequestInvite.vue
// module id = 1472
// module chunks = 1